import { gql } from '@apollo/client/core';
import React from 'react';
import { Image } from '..';

export default function ProfileLogo({
  companyProfile,
  height,
  width,
  ...rest
}) {
  if (!hasContent(companyProfile)) return null;
  return (
    <Image
      src={companyProfile?.logo?.url}
      height={height}
      width={width}
      trim
      {...rest}
    />
  );
}

ProfileLogo.hasContent = hasContent;

function hasContent(companyProfile) {
  return !!companyProfile?.logo?.url;
}

ProfileLogo.fragment = gql`
  fragment ProfileLogo on Profile {
    logo {
      url
    }
  }
`;
